import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Map as olMap } from 'ol';
import 'ol/ol.css';
import { fromLonLat, transformExtent, get } from 'ol/proj';
import { boundingExtent } from 'ol/extent';
import XYZ from 'ol/source/XYZ';
import Overlay from 'ol/Overlay.js';
import View from 'ol/View';
import { Tile as TileLayer } from 'ol/layer';

import './Map.css';
import emptyMap from './emptyMap.png';
import MapMarker from './mapMarker/MapMarker';
import Label from '../label/Label';

let activeIcons = {
	'check-outline-white': 'check-outline-green',
	'trash-outline-white': 'trash-outline-red',
	'calendar-outline-white': 'calendar-outline-blue',
	'discrepancy-outline-white': 'discrepancy-outline-orange'
};

let inactiveIcons = {
	'check-outline-green': 'check-outline-white',
	'trash-outline-red': 'trash-outline-white',
	'calendar-outline-blue': 'calendar-outline-white',
	'discrepancy-outline-orange': 'discrepancy-outline-white'
};

export let makeIconActive = (element) => {
	if (!element) return;
	if (!element.classList) return;
	let inactiveIcon = hasAnyClass(inactiveIcons, element.classList);
	if (inactiveIcon) {
		element.classList.remove(inactiveIcon);
		element.classList.add(activeIcons[inactiveIcon]);
	}
	removeActiveClass();
	element.parentElement.parentElement.classList.add('active');
};

export let removeActiveClass = () => {
	let allIcons = document.querySelectorAll('.icon-container.active');
	for (let i in allIcons) {
		let icon = allIcons[i];
		if (!icon) continue;
		if (!icon.classList) continue;
		icon.classList.remove('active');
	}
};

export let makeIconInactive = (element) => {
	if (!element) return;
	if (!element.classList) return;
	let activeIcon = hasAnyClass(activeIcons, element.classList);
	element.classList.remove(activeIcon);
	element.classList.add(inactiveIcons[activeIcon]);
	element.parentElement.parentElement.classList.remove('active');
};

export let makeAllIconsInactive = () => {
	for (let i in activeIcons) {
		let elements = document.querySelectorAll('.' + activeIcons[i]);
		for (let j in elements) {
			makeIconInactive(elements[j]);
		}
	}
};

//I set this up to receive an array of coordinate objects (formatted {lat: #####, lng: #####} in Degree decimals) drug details page should go get the coordinate objects for the specific drug and pass it into component as props
export default class Map extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasData: true
		};
		this.mapId = `map-${Date.now()}`;
	}

	componentDidMount() {
		this.buildMap(this.props);
	}

	componentDidUpdate() {
		this.buildMap(this.props);
	}

	buildMap = async (props) => {
		// find center
		if (this.olmap && this.olmap.dispose) this.olmap.dispose();
		let coords = props.coords;
		let { minLon, minLat, maxLon, maxLat } = this.getFourCorners(coords);
		let extent = boundingExtent([[minLon, minLat], [maxLon, maxLat]]);
		extent = transformExtent(extent, get('EPSG:4326'), get('EPSG:3857'));

		//build map
		// let vectorLayer = this.createVectorIcons(coords);
		let view = new View({
			// center: fromLonLat([-3.683333, 40.4]),
			// fit: polygon,
			// extent:extent,
			zoom: 15
		});

		let tileLayer = new TileLayer({
			updateWhileAnimating: true,
			updateWhileInteracting: true,
			source: new XYZ({
				url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
				attributions: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
			})
		});
		this.olmap = new olMap({
			target: this.mapId,
			layers: [tileLayer],
			view
		});
		this.addHtmlIcons(coords);
		view.fit(extent);
	};
	getFourCorners = (coords) => {
		let minLon = null;
		let maxLon = null;
		let minLat = null;
		let maxLat = null;
		for (let i in coords) {
			let lat = coords[i].lat;
			let lon = coords[i].lon;
			if (!minLon) minLon = lon;
			if (!maxLon) maxLon = lon;
			if (!minLat) minLat = lat;
			if (!maxLat) maxLat = lat;
			if (lat > maxLat) maxLat = lat;
			if (lon > maxLon) maxLon = lon;
			if (lat < minLat) minLat = lat;
			if (lon < minLon) minLon = lon;
		}
		return { minLon: minLon - 0.001, minLat: minLat - 0.001, maxLat: maxLat + 0.001, maxLon: maxLon + 0.001 };
	};
	//
	// createVectorIcons = (coords) => {
	//   let points = [];
	//   for (let i in coords) {
	//     let markerLng = coords[i].lon;
	//     let markerLat = coords[i].lat;
	//     let markerCoords = fromLonLat([markerLng, markerLat]);
	//
	//     let pointOnMap = new Feature({
	//       geometry: new Point(markerCoords)
	//     });
	//
	//     pointOnMap.setStyle(new Style({
	//       image: new Icon({
	//         crossOrigin: 'anonymous',
	//         src: randomImage(images)
	//       })
	//     }));
	//     points.push(pointOnMap);
	//   }
	//   let vectorSource = new VectorSource({
	//     features: points
	//   });
	//
	//   let vectorLayer = new VectorLayer({
	//     source: vectorSource
	//   });
	//   return vectorLayer;
	// };

	addHtmlIcons = (coords) => {
		for (let i in coords) {
			let coord = coords[i];
			let markerCoordsFinal = fromLonLat([coord.lon, coord.lat]);
			const marker = document.createElement('div');
			let div = <MapMarker onClick={this.iconClick} {...coord} />;
			ReactDOM.render(div, marker);
			const markerLayer = new Overlay({
				position: markerCoordsFinal,
				positioning: 'center-center',
				element: marker,
				stopEvent: false,
				className: 'icon-container',
				anchor: [0.5, 46],
				anchorXUnits: 'fraction',
				anchorYUnits: 'pixels'
			});
			this.olmap.addOverlay(markerLayer);
		}
	};

	iconClick = (e, itemId) => {
		let classList = e.target.classList;
		makeAllIconsInactive();
		makeIconActive(e.target, classList);
		this.props.onIconClick(itemId);
	};

	makeIconActive = (id, lat, long) => {
		for (let i in activeIcons) {
			let elements = document.querySelectorAll('.' + activeIcons[i]);
			for (let j in elements) {
				makeIconInactive(elements[j]);
			}
		}
		makeIconActive(document.querySelector(`[data-id="${id}"]`));
		// this.olmap.getView().setCenter();
		this.olmap.getView().animate({}, { duration: 2000, center: fromLonLat([long, lat]) });
	};

	renderNothingToShow = () => {
		return (
			<div className="no-data-container">
				<Label>No Activity</Label>
				<img draggable={false} src={emptyMap} alt="No Activity" />
			</div>
		);
	};

	render() {
		let hasData = false;
		if (this.props.coords && this.props.coords.length > 0) {
			hasData = true;
		}
		return (
			<div id="map-holder" className={this.props.className}>
				{hasData ? null : this.renderNothingToShow()}
				<div className="map" id={this.mapId} />
			</div>
		);
	}
}

let hasAnyClass = (classNames, classList) => {
	for (let i in classNames) {
		if (hasClass(classNames[i], classList)) {
			return classNames[i];
		}
	}
	return false;
};

let hasClass = (className, classList) => {
	for (let i in classList) {
		if (classList[i] === className) {
			return true;
		}
	}
	return false;
};
//
// let randomImage = (images) => {
//   let index = Math.floor(Math.random() * (images.length));
//   return images[index];
// };
// let randomIcon = () => {
//   let icons = ['check-outline-green', 'check-outline-white', 'discrepancy-outline-white', 'discrepancy-outline-orange', 'calendar-outline-white', 'calendar-outline-blue', 'trash-outline-white', 'trash-outline-red'];
//   let index = Math.floor(Math.random() * (icons.length));
//   return icons[index];
// };
//



// WEBPACK FOOTER //
// ./src/components/map/Map.jsx